export default __webpack_public_path__ + "static/studio-to-sea-3ff148434e99d25efc8598af019a9762.webp";